export default __webpack_public_path__ + "static/media/a1.1b87e23f.png";